import { useContext, useCallback } from 'react';
import { Oidc } from '@annunciate/web/dist/context';
import { Topic, messageFactory } from '@annunciate/core';
import { POST_LOGIN_REDIRECT_URI } from '../utils/navigation';
export const useLoginRedirect = () => {
    const ctx = useContext(Oidc);
    return useCallback(async ({ postLoginUri = undefined, loginHint = undefined, } = {}) => {
        const redirect = window.location.href;
        let resolvePostLoginUri = postLoginUri;
        if (!resolvePostLoginUri) {
            const postlogin = new URL(window.location.href);
            resolvePostLoginUri = postlogin.searchParams.get(POST_LOGIN_REDIRECT_URI) || undefined;
        }
        await messageFactory(Topic.APP_AUTHENTICATION_STARTED);
        ctx.signIn(resolvePostLoginUri || redirect, loginHint);
    }, [ctx]);
};
//# sourceMappingURL=useLoginRedirect.js.map